const dateTimeUtil = {
  formate (fmt, date) {
    let ret
    const opt = {
      'Y+': date.getFullYear().toString(), // 年
      'm+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'H+': date.getHours().toString(), // 时
      'M+': date.getMinutes().toString(), // 分
      'S+': date.getSeconds().toString() // 秒
    }
    for (const k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
      };
    };
    return fmt
  },
  defaultFormate (val) {
    return val ? this.formate('YYYYmmdd', new Date(val)) : null
  },
  defaultFullTimeFormate (val,dateSplitChar) {
    let yearSplitChar = '';
    let monthSplitChar = '';
    let daySPlitChar = '';
    dateSplitChar = dateSplitChar || '-';
    if(dateSplitChar.length == 3){
      yearSplitChar = dateSplitChar[0];
      monthSplitChar = dateSplitChar[1];
      daySPlitChar = dateSplitChar[2];
    }
    else{
      yearSplitChar = monthSplitChar = dateSplitChar = dateSplitChar;
    }
    return val ? this.formate(`YYYY${yearSplitChar}mm${monthSplitChar}dd${daySPlitChar} HH:MM:SS`, new Date(val)) : null
  },
  defaultISOTimeFormate (val) {
    return val ? `${this.formate('YYYY-mm-dd', new Date(val))}T${this.formate('HH:MM:SS', new Date(val))}` : null
  }
}

export default dateTimeUtil
